<template>
	<AppFilter @apply="onFilter" v-model="filters" :isPadding="true" ref="appFilter"/>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		name:"productAdvanceFilter",
		props: {

		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {
			selectedPartner: {
				async handler() {
					this.productAdvanceFilter = []
					await this.getData()
					this.setFilters()
				}
			},
			isSeller: {
				async handler(){
					this.brand_managers = await this.$store.dispatch("product/getBrandManagers")
				}
			}
		},
		computed: {
			productAdvanceFilter:{
				set(val){
					this.$store.commit('updateProductsFilter',val)
				},
				get(){
					return this.$store.state.productAdvanceFilter
				}
			},
			selectedPartner:{
				set(val){
				},
				get(){
					return this.$store.state.selectedVendorPartnerUuid
				}
			},
			isSeller:{
				set(val){
				},
				get(){
					return this.$store.state.isSeller
				}
			}
		},
		async mounted() {
			this.brand_managers = await this.$store.dispatch("product/getBrandManagers")

			await this.getData()
			this.setFilters()

		},
		methods: {
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
					filters[input[i].name] = input[i].value;
				}

				filters.advanceSearchType = "product";
				let payload = {};

				console.log('FILTERS: ', filters)

				if (filters['hidden']){
					this.$store.state.showHidden = filters['hidden'].value
				} else {
					this.$store.state.showHidden = false
				}

				payload.tagFilters = []

				if(filters["brand"]){
					payload.tagFilters.push(filters['brand'])
				}

				if(filters["category"]){
					payload.tagFilters.push(filters['category'])
				}

				if(filters["subcategory"]){
					payload.tagFilters.push(filters['subcategory'])
				}

				if(filters["style"]){
					payload.tagFilters.push(filters['style'])
				}

				if(filters["product_group"]){
					payload.tagFilters.push(filters['product_group'])
				}

				if(filters["size"]){
					payload.tagFilters.push(filters['size'])
				}

				if(filters["flavor"]){
					payload.tagFilters.push(filters['flavor'])
				}

				if(filters["competitor"]){
					payload.tagFilters.push(filters['competitor'])
				}

				if(filters["color"]){
					payload.tagFilters.push(filters['color'])
				}

				if(filters["brand_manager"]){
					payload.brandManager = filters['brand_manager'].value
				}
				
				console.log('FILTERING')
				this.$store.state.currentPageNumber = 1;
				this.$store.commit("product/setadvanceFilterProduct", payload);
				this.$emit("getFilterProducts");
				await this.getData()
				this.setFilters()
			},
			async getData(){
				console.log("GETTING DATA")
				const vm = this;
				const additionalOptions = [
					{type: 'brand_product', title: 'UNTAGGED', untagged: true},
					{type: 'category_product', title: 'UNTAGGED', untagged: true},
					{type: 'sub_category_product', title: 'UNTAGGED', untagged: true},
					{type: 'style_product', title: 'UNTAGGED', untagged: true},
					{type: 'product_group_product', title: 'UNTAGGED', untagged: true},
					{type: 'size_product', title: 'UNTAGGED', untagged: true},
					{type: 'flavor_product', title: 'UNTAGGED', untagged: true},
					{type: 'gl_product', title: 'UNTAGGED', untagged: true},
					{type: 'competitor_product', title: 'UNTAGGED', untagged: true},
					{type: 'color_product', title: 'UNTAGGED', untagged: true},
				]
				await this.$store.dispatch("product/getTagOptions", { partneruuid: this.$store.state.selectedVendorPartnerUuid, isSeller: this.$store.state.isSeller }).then((res) => {
					const tagOptions = (res || []).concat(additionalOptions)
					vm.$store.state.listOfTags = tagOptions
					vm.brand_tags_List = tagOptions.filter(t => t.type === 'brand_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.category_tags_List = tagOptions.filter(t => t.type === 'category_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.subcategory_tags_List = tagOptions.filter(t => t.type === 'sub_category_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.style_tag_list = tagOptions.filter(t => t.type === 'style_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.product_group_tags_List = tagOptions.filter(t => t.type === 'product_group_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.size_tags_List = tagOptions.filter(t => t.type === 'size_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.flavor_tags_List = tagOptions.filter(t => t.type === 'flavor_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.gl_tag_list = tagOptions.filter(t => t.type === 'gl_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.competitor_tag_list = tagOptions.filter(t => t.type === 'competitor_product').map(t => ({...t, name: t.title, value: t.title}))
					vm.color_tag_list = tagOptions.filter(t => t.type === 'color_product').map(t => ({...t, name: t.title, value: t.title}))
				})
			},
			setFilters() {
				// this.filters = [];

				if (this.productAdvanceFilter.length > 0) {
					this.filters = this.productAdvanceFilter
					return 
				}
				this.filters = [
					{
						name: "break",
						type: "break"
					},
					{
						name: "hidden",
						label: "Show Hidden Products",
						type: "select",
						placeholder: "Select",
						value: this.hidden,
						enabled: false,
						values: [{name:'True', value:true}, {name:'False', value:false}],
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "brand_manager",
						label: "Brand Manager",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.brand_managers.map( m => ({name: `${m.first_name} ${m.last_name}`, value: {first_name:m.first_name, last_name:m.last_name}})),
						padding:true
					},
                    {
						name: "break",
						type: "break"
					},
					{
						name: "brand",
						label: "Brand",
						type: "select",
						placeholder: "Select",
						value: this.brand_tag,
						enabled: false,
						values: this.brand_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "category",
						label: "Category",
						type: "select",
						placeholder: "Select",
						value: this.category_tag,
						enabled: false,
						values: this.category_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "subcategory",
						label: "Sub-Category",
						type: "select",
						placeholder: "Select",
						value: this.subcategory_tag,
						enabled: false,
						values: this.subcategory_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "style",
						label: "Style",
						type: "select",
						placeholder: "Select",
						value: this.style_tag,
						enabled: false,
						values: this.style_tag_list,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "product_group",
						label: "Product Group",
						type: "select",
						placeholder: "Select",
						value: this.product_group_tag,
						enabled: false,
						values: this.product_group_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "size",
						label: "Size",
						type: "select",
						placeholder: "Select",
						value: this.size_tag,
						enabled: false,
						values: this.size_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "flavor",
						label: "Flavor",
						type: "select",
						placeholder: "Select",
						value: this.flavor_tag,
						enabled: false,
						values: this.flavor_tags_List,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "gl",
						label: "GL",
						type: "select",
						placeholder: "Select",
						value: this.gl_tag,
						enabled: false,
						values: this.gl_tag_list,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "competitor",
						label: "Competitor",
						type: "select",
						placeholder: "Select",
						value: this.competitor_tag,
						enabled: false,
						values: this.competitor_tag_list,
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "color",
						label: "Color",
						type: "select",
						placeholder: "Select",
						value: this.color_tag,
						enabled: false,
						values: this.color_tag_list,
						padding:true
					},
					{
						name: "break",
						type: "break"
					}

				];
				this.productAdvanceFilter = JSON.parse(JSON.stringify(this.filters))
			}

		},
		data() {
			return {
				filters: [],
				list : [],
				brand_managers: [],
				brand_tags_List:[],
				category_tags_List:[],
				subcategory_tags_List:[],
				style_tag_list:[],
				product_group_tags_List:[],
				size_tags_List:[],
				flavor_tags_List:[],
				gl_tag_list:[],
				competitor_tag_list:[],
				color_tag_list:[],
				hidden: [],
				brand_tag: [],
				category_tag: [],
				subcategory_tag: undefined,
				style_tag: undefined,
				product_group_tag: undefined,
				size_tag: undefined,
				flavor_tag: undefined,
				gl_tag: undefined,
				competitor_tag: undefined,
				color_tag: undefined
				// copyRetainFilter:[]
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
